// extracted by mini-css-extract-plugin
export var fullWidthButton = "_gw-0";